export default __webpack_public_path__ + "static/media/close-mini-schedule-icon.ba1bfd1a.svg";